import jwtAuthAxios from "./auth/jwtAuth";

// Llaves de la API de integraciones de la empresa activa. Ver hermes-backend
// app/controllers/api/v1/integration_keys_controller.rb.
const integrationKeyServices = {};

integrationKeyServices.list = async () => (await jwtAuthAxios.get("/integration_keys")).data;

// La respuesta trae el token: es la única vez que se puede ver.
integrationKeyServices.create = async (name) => (await jwtAuthAxios.post("/integration_keys", { name })).data;

integrationKeyServices.rotate = async (id, graceHours) =>
    (await jwtAuthAxios.post(`/integration_keys/${id}/rotate`, { grace_hours: graceHours })).data;

integrationKeyServices.revoke = async (id) => (await jwtAuthAxios.delete(`/integration_keys/${id}`)).data;

export default integrationKeyServices;
